export const createMessageAPI = (fetchApi) => {
  function getMessage(messageKey, oneTimeCode, refreshKey) {
    return fetchApi(`/Message?key=${messageKey}&content=true&urlParam=${oneTimeCode}&refreshKey=${refreshKey}`, "GET");
  }

  return {
      getMessage,
  };
};
